import { makeStyles } from '@material-ui/core/styles';

export const useFormReaderStyles = makeStyles(theme => ({
  formReader: {
    flexGrow: 1
  }
}));
